import { View } from "@pimo/pimo-app-builder";
import {
  DragAndDropLayout,
  PMBarChartCard,
  PMDonutChartCard,
} from "@pimo/pimo-components";

import { TestAppState } from "../../../app";
import { DONUT_CARD_LAYOUT } from "../../../constants";
import {
  getAllReportingItems,
  getDistributionChannelData,
  withTotalInTitle,
} from "../get-dashboard-chart-data";

/**
 * Adds the "systems per distribution channel" bar and donut chart cards, in
 * that order (#2222).
 */
export function addDistributionChannelDashboardCards(
  view: View<TestAppState, DragAndDropLayout>
) {
  const distributionChannelsBarChartComponent = view.addComponent({
    component: PMBarChartCard,
    layoutProps: {
      componentId: "distributionChannelsDashboardBarChartComponent",
      labels: ["barChart", "chart", "distributionChannel"],
      description:
        "Shows systems grouped by distribution channel across all projects.",
      title: "Systems per Distribution Channels (Bar Chart)",
    },
  });

  distributionChannelsBarChartComponent.mapState(({ dashboard, settings }) => {
    const allItems = getAllReportingItems(dashboard);
    const { entries } = getDistributionChannelData(
      allItems,
      settings?.configuration?.distributionChannelDefinition
    );

    return {
      title: "Systems per Distribution Channels (Bar Chart)",
      categories: entries.map((entry) => entry.label),
      data: entries.map((entry) => entry.count),
      chartType: 1 as const,
      xLabel: "Systems",
      yLabel: "Distribution Channel",
      colors: entries.map((entry) => entry.color),
      fixedHeight: "320px",
    };
  });

  const distributionChannelsDonutChartComponent = view.addComponent({
    component: PMDonutChartCard,
    layoutProps: {
      componentId: "distributionChannelsDashboardDonutChartComponent",
      labels: ["donutChart", "chart", "distributionChannel"],
      description:
        "Shows systems grouped by distribution channel across all projects.",
      title: "Systems per Distribution Channels (Donut Chart)",
    },
  });

  distributionChannelsDonutChartComponent.mapState(
    ({ dashboard, settings }) => {
      const allItems = getAllReportingItems(dashboard);
      const { entries } = getDistributionChannelData(
        allItems,
        settings?.configuration?.distributionChannelDefinition
      );

      return {
        title: withTotalInTitle(
          "Systems per Distribution Channels (Donut Chart)",
          allItems.length
        ),
        icon: "DonutLarge",
        ...DONUT_CARD_LAYOUT,
        data: entries.map((entry) => ({
          label: entry.label,
          value: entry.count,
          color: entry.color,
        })),
      };
    }
  );
}
